import clsx from 'clsx';
import Tabs, { TabItemManager, TabsStyles } from '../../nav/Tabs';
import { ReactNode, useEffect, useState } from 'react';

export const TabNavigationLayout = <T extends string>({
  tabs,
  activeTab,
  children,
  renderTabs,
  hideBorderBottom = false,
}: {
  tabs: TabItemManager['tabs'];
  activeTab: T;
  children: ReactNode;
  hideBorderBottom?: boolean;
  renderTabs?: (tabsContent: ReactNode) => ReactNode;
}) => {
  const [currentTab, setCurrentTab] = useState(
    tabs.find((t) => t.key === activeTab) || tabs[0],
  );
  useEffect(() => {
    const newActiveTab = tabs.find((t) => t.key === activeTab);
    if (newActiveTab) {
      setCurrentTab(newActiveTab);
    }
  }, [activeTab, tabs]);
  const tabsManager: TabItemManager = {
    tabs,
    currentTab,
    setCurrentTab,
  };
  const TabsContent = (
    <div
      className={clsx(
        'px-8 w-full',
        !hideBorderBottom && 'border-b border-gray-100',
      )}
    >
      <Tabs tabsManager={tabsManager} style={TabsStyles.UNDERLINED} />
    </div>
  );

  return (
    <div className="flex flex-col w-full h-full">
      {renderTabs ? renderTabs(TabsContent) : TabsContent}
      {children}
    </div>
  );
};
